import axios from 'axios'

import router from '@/router'

import { useTokenStore } from '@/stores'

// 存储所有正在进行的请求控制器
const pendingRequests = new Map()

// 创建axios实例
const request = axios.create({
  baseURL: import.meta.env.VITE_API_PREFIX || '/prod-api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// 生成请求唯一标识
const generateRequestKey = (config) => {
  let requestKey = `${config.method}_${config.url}_${JSON.stringify(config.params)}_${JSON.stringify(config.data)}`

  // 查看 formData 信息
  if (config?.data instanceof FormData) {
    for (let [key, value] of config.data.entries()) {
      requestKey = `${requestKey}_${key}_${value.name}`
    }
  }

  return requestKey
}

// 添加请求到待处理列表
function addPendingRequest(config) {
  const requestKey = generateRequestKey(config)
  // 如果已经存在，先取消之前的请求
  if (pendingRequests.has(requestKey)) {
    const controller = pendingRequests.get(requestKey)
    controller?.abort()
    // config?.abort()
  }

  // 创建新的控制器
  const controller = new AbortController()
  config.signal = controller.signal

  pendingRequests.set(requestKey, controller)
}

// 移除已完成的请求
function removePendingRequest(config) {
  const requestKey = generateRequestKey(config)
  pendingRequests.delete(requestKey)

  pendingRequests.forEach((controller, key) => {})

  if (pendingRequests.size == 0) {
    toast.close()
  }
}

// 取消所有请求
export const cancelAllRequests = () => {
  pendingRequests.forEach((controller) => {
    controller.abort()
  })
  pendingRequests.clear()

  if (pendingRequests.size == 0) {
    toast.close()
  }
}

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    // 添加请求到待处理列表
    addPendingRequest(config)
    if (pendingRequests.size > 0) {
      // toast.loading()
    }

    // 可以在这里添加认证token等
    const { getToken, getRefreshtoken } = useTokenStore()
    const token = getToken
    const refreshtoken = getRefreshtoken
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      config.headers.Refreshtoken = `${refreshtoken}`
    }

    // 如果是 FormData，让浏览器自动设置 Content-Type
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    removePendingRequest(response.config)

    const { code, data, msg } = response.data

    if (code === 200) {
      // 确保返回类型匹配
      return response.data
    } else if (code === 401) {
      console.log('🚀 ~ msg:', response.data)

      // 成功时返回完整的业务数据
      router.replace('/login')
      return Promise.reject(new Error('token失效'))
    } else {
      // 可以根据业务需求处理不同的错误码
      toast.error(msg || '请求失败')
      return Promise.reject(new Error(msg || '请求失败'))
    }
  },
  (error) => {
    // 如果是取消请求的错误，直接返回
    if (error.message == 'canceled') {
      return Promise.reject(error)
    }
    removePendingRequest(error.config)
    // 避免在身份验证失败时显示网络错误
    if (error.message !== 'token失效') {
      toast.error('网络异常，请稍后再试')
    }
    return Promise.reject(error)
  },
)

export default request
